var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHelp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .svg-help {\n                fill: #fff\n            }\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons_Top_copy",
    "data-name": "Icons Top copy"
  }, /*#__PURE__*/React.createElement("path", {
    className: "svg-help",
    d: "M15.11,21.14A1.16,1.16,0,0,1,14,20V17.13A1.16,1.16,0,0,1,15.11,16a3.23,3.23,0,1,0-3.22-3.22,1.16,1.16,0,0,1-2.31,0,5.54,5.54,0,1,1,6.69,5.41V20A1.16,1.16,0,0,1,15.11,21.14Zm0-12.54a4.15,4.15,0,1,1,0,8.3.22.22,0,0,0-.22.23V20a.23.23,0,1,0,.45,0V17.77a.46.46,0,0,1,.4-.46,4.61,4.61,0,1,0-5.23-4.56.23.23,0,1,0,.45,0A4.16,4.16,0,0,1,15.11,8.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "svg-help",
    d: "M15.11,24.33a1.27,1.27,0,1,1,1.27-1.27A1.27,1.27,0,0,1,15.11,24.33Zm0-1.6a.34.34,0,0,0,0,.67.34.34,0,1,0,0-.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "svg-help",
    d: "M15,30A15,15,0,1,1,30,15,15,15,0,0,1,15,30ZM15,.93A14.07,14.07,0,1,0,29.07,15,14.08,14.08,0,0,0,15,.93Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.698373d5.svg";
export { ForwardRef as ReactComponent };